import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyPipelineAccess = createSelector(
  selectSubCompany,
  subCompany =>
    subCompany?.pipelineAccess || {
      isLoaded: false,
      hasLoadFailed: false,
      roles: [],
      pipelines: [],
    },
);
